module.exports = __webpack_public_path__ + "img/hulizhuanyepeixun.651e8356.png";